import React from "react";
import { ChevronRight } from "lucide-react";
import { HERO } from "../mock";
import { useValuation } from "./ValuationDialog";

export default function Hero() {
  const { openValuation } = useValuation();
  return (
    <section id="home" className="relative h-screen min-h-[620px] w-full overflow-hidden">
      <img
        src={HERO.image}
        onError={(e) => (e.currentTarget.src = HERO.fallback)}
        alt="Letting agents in North London"
        className="absolute inset-0 h-full w-full object-cover animate-kenburns"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        <h1 className="font-display text-4xl font-700 uppercase leading-none tracking-wide text-white drop-shadow-lg animate-fade-up sm:text-6xl lg:text-7xl">
          {HERO.title}
        </h1>
        <p className="mt-5 max-w-3xl font-display text-lg font-300 uppercase tracking-[0.15em] text-white/90 drop-shadow animate-fade-up sm:text-2xl">
          {HERO.subtitle}
        </p>
        <div className="mt-9 flex flex-col gap-4 sm:flex-row animate-fade-up">
          <button
            onClick={openValuation}
            className="group flex items-center justify-center gap-2 rounded-full bg-[#ec008c] px-9 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-[#c60074]"
          >
            Request a Valuation
            <ChevronRight size={16} className="transition-transform group-hover:translate-x-1" />
          </button>
          <a
            href="#contact"
            className="group flex items-center justify-center gap-2 rounded-full bg-[#eaa32a] px-9 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-[#d18f1e]"
          >
            Talk to us
            <ChevronRight size={16} className="transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
